const NMSDC = { code: "NMSDC", description: "" };
const WBENC = { code: "WBENC", description: "" };
const NGLCC = { code: "NGLCC", description: "" };

export default {
    NMSDC,
    WBENC,
    NGLCC
};




// WEBPACK FOOTER //
// ./src/areas/admin/certification/certificationInfo/businessCertification/UploadsConfig.js